import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import HowItWorks from "@/components/HowItWorks";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";

export default function HomePage() {
    return (
        <main>
            <Hero />
            <Marquee />
            <Services />
            <HowItWorks />
            <Testimonials />
            <Contact />
        </main>
    );
}
